<!-- @format -->

<div class="help-and-feedback-menu" [class.help-and-feedback-menu--mobile]="mobileMode">
  @if (helpUrl$ | async; as helpUrl) {
    <ng-container
      [ngTemplateOutlet]="externalLink"
      [ngTemplateOutletContext]="{ url: helpUrl, name: 'ARIA_LABEL.HELP' | transloco, iconLink: !navCollapsed }" />
  }
  @if (universityLinks$ | async; as universityLinks) {
    @if (universityLinks?.length > 0 && authenticated()) {
      @for (link of universityLinks; track link) {
        <ng-container
          [ngTemplateOutlet]="externalLink"
          [ngTemplateOutletContext]="{ url: link.url, name: link.name | localizedString: currentLanguage }" />
      }
    }
  }
</div>
<ng-template #externalLink let-url="url" let-name="name" let-iconLink="iconLink">
  <a
    ngbDropdownItem
    fudisLink
    role="menuitem"
    [href]="url"
    [title]="name"
    [external]="true"
    target="_blank"
    class="help-and-feedback-menu__item d-block"
    [class.d-none]="iconLink"
    (blur)="blurMobileHelpAndFeedbackMenu.emit($event)"
    (keydown.escape)="blurMobileHelpAndFeedbackMenu.emit($event)"
    (keydown)="keydownPressed.emit($event)"
    rel="noopener noreferrer">
  </a>
</ng-template>
